import { type ComponentPublicInstance, defineAsyncComponent } from 'vue';

const Layouts: Record<string, new () => ComponentPublicInstance> = {
  addon: defineAsyncComponent(() => import('./addon.vue')),
  auth: defineAsyncComponent(() => import('./auth.vue')),
  error: defineAsyncComponent(() => import('./error.vue')),
  game: defineAsyncComponent(() => import('./game.vue')),
  default: defineAsyncComponent(() => import('./default.vue')),
  globalLayout: defineAsyncComponent(() => import('./global/index.vue')),
  internalDashboard: defineAsyncComponent(() => import('./internalDashboard.vue')),
  orgDashboard: defineAsyncComponent(() => import('./orgDashboard.vue')),
  qfwPricing: defineAsyncComponent(() => import('./qfwPricing.vue')),
  salesDashboard: defineAsyncComponent(() => import('./salesDashboard.vue')),
  signupDashboard: defineAsyncComponent(() => import('./signupDashboard.vue')),
  blank: defineAsyncComponent(() => import('./blank.vue')),
};

export default Layouts;
